import { useParams } from "react-router-dom";
import { useModal } from "../../../../contexts/ModalContext";
import { useDialog } from "../../../../contexts/DialogContext";
import TableComplete from "../../../../components/Tables/TableComplete";
import { Circle } from "../../../../components/Animation";
import { Anchor, H2, H3 } from "../../../../components/Text";
import { FillForm, SendProcedure } from "../../../../containers/steps";
import { Request } from "../../../../hooks/Request";
import { validateArray } from "../../../../utils/validate";
import dayjs from "dayjs";
import { Button } from "../../../../components/Buttons";
import { useNavigate } from "react-router-dom";
import { FormQuotes } from "../../../../containers/ManegeProcedure/FormQuotes";
import ServiceOrderPDF from "../../../../containers/ManegeProcedure/ServiceOrderPDF";
import BankDepositReconciliation from "../../../../containers/ManegeProcedure/BankDepositReconciliation";
import CustomsClearanceCollectionNote from "../../../../containers/ManegeProcedure/CustomsClearanceCollectionNote";
import ProofDeliveryDocument from "../../../../containers/ManegeProcedure/ProofDeliveryDocument";
import CustomsClearanceForm from "../../../../containers/ManegeProcedure/CustomsClearanceForm";
import { FormDepositReconciliation } from "../../../../containers/ManegeProcedure/FormDepositReconciliation";
import { Tooltip } from "react-tippy";
import { FormDocumentsDeliver } from "../../../../containers/ManegeProcedure/FormDocumentsDeliver";
import CustomsClearancePdf from "../../../../containers/ManegeProcedure/CustomsClearancePdf";
import CustomsClearanceQuote from "../../../../containers/ManegeProcedure/CustomsClearanceQuote";
import { requestAuth } from "../../../../components/services/RequestService";
import { formattedValue } from "../../../../utils/utils";

const listFields = [
  "analizarDocumentación",
  "observaciones(RecepciónYRevisión)",

  "elaborarDam",
  "adjuntarDamFirmada",

  "elaborarLiquidaciónDeTributos",

  "elaborarDim",
  "adjuntarDim",

  "elaborarDav",
];

const FolderStep = () => {
  const { rolId, procedureId } = useParams();
  const { openModal, onClose } = useModal();
  const { openDialog } = useDialog();
  const navigate = useNavigate();

  const {
    data: dataValues,
    loading: loadingValues,
    call: callValues,
  } = Request({
    urlApi: `/Procedure/${procedureId}/dataValues?${listFields
      .map((field) => `fieldnames=${field}`)
      .join("&")}`,
  });

  const { data, loading, call } = Request({
    urlApi: `/procedure/${procedureId}/general`,
  });

  async function getNotesValueData() {
    try {
      const fieldsResponse = await requestAuth(
        "get",
        `/Procedure/${procedureId}/datasets?fieldnames=notaDeValor`,
      );
      const notaDeValorField = fieldsResponse.data?.find(
        (field) => field.name === "notaDeValor",
      );

      if (notaDeValorField) {
        const notesResponse = await requestAuth(
          "get",
          `/dataSet/procedure/${procedureId}/field/${notaDeValorField.id}/subdata`,
        );
        return notesResponse.data;
      }
      return [];
    } catch (error) {
      console.error("Error obteniendo datos de notas de valor:", error);
      return [];
    }
  }

  async function handleFormQuotes(procedure) {
    const notesValueData = await getNotesValueData();
    openDialog(
      <CustomsClearanceQuote
        procedure={procedure}
        notesValueData={notesValueData}
      />,
    );
    // openModal(
    //   <FormQuotes procedure={{ ...procedure, id: procedure.procedureId }} />
    // );
  }

  function generateServiceOrder(procedure) {
    openDialog(
      <ServiceOrderPDF
        procedure={{ ...procedure, id: procedure.procedureId }}
      />,
    );
  }

  function generateBankDepositReconciliation(procedure) {
    openModal(
      <FormDepositReconciliation
        procedure={{ ...procedure, id: procedure.procedureId }}
      />,
    );
    // openDialog(
    //   <BankDepositReconciliation
    //     procedure={{ ...procedure, id: procedure.procedureId }}
    //   />
    // );
  }

  function generateCustomsClearanceCollectionNote(procedure) {
    openDialog(
      <CustomsClearanceCollectionNote
        procedure={{ ...procedure, id: procedure.procedureId }}
      />,
    );
  }

  function generateProofDeliveryDocument(procedure) {
    openModal(
      <FormDocumentsDeliver
        procedure={{ ...procedure, id: procedure.procedureId }}
      />,
    );
  }

  function generateCustomsClearanceForm(procedure) {
    if (data.category === "multiple") {
      var win = window.open(
        `/rol/${rolId}/procedure-type/${1}/step/1/procedure/${
          procedure.procedureId
        }/generate/clone-items`,
        // `/rol/${rolId}/procedure-type/${procedure.procedureTypeId}/step/1/procedure/${procedure.id}/generate/clone-items`,
        "_blank",
      );
      win.focus();
      openDialog(
        <div className="w-[400px]">
          <H3 className="text-[1.4rem]">
            El tramite {procedure.number} es un tramite multiple
          </H3>
          <center>
            <Anchor
              className="text-[#264fbe] text-[1.2rem]"
              href={`/rol/${rolId}/procedure-type/${1}/step/1/procedure/${
                procedure.procedureId
              }/generate/clone-items`}
              // download
              target="_blank"
              rel="noopener noreferrer"
            >
              Ir a la pagina de items
            </Anchor>
          </center>
          <br />
        </div>,
      );
    } else {
      openDialog(<CustomsClearancePdf procedure={procedure} />);
      // openModal(
      //   <CustomsClearanceForm
      //     procedure={{ ...procedure, id: procedure.procedureId }}
      //   />
      // );
    }
  }

  function handleStepForm(step) {
    // (step.startDate && step.startDate !== null) ||
    // (step.finishDate && step.finishDate !== null)
    //   ?
    openModal(
      <FillForm
        procedure={{
          id: data.procedureId,
          processStepId: step.processStepId,
          category: data.category,
        }}
        reload={() => {
          callValues();
          call();
        }}
        onClose={onClose}
        openModal={openModal}
        rolId={rolId}
        rols={step.rols}
        // step={rol === "accountant" ? "4" : "3"}
        step={step.step}
        typeId={data.processStepId}
        handleSendProcedure={handleSendProcedure}
      />,
    );
    // : openDialog(
    //     <div className="mb-5 text-center">
    //       <h2 className="text-xl">
    //         Debes llenar el paso en progreso primero
    //       </h2>
    //       <h3 className="">
    //         Paso en progreso:{" "}
    //         <span className="font-medium">{data.processStepName}</span>{" "}
    //       </h3>
    //     </div>
    //   );
  }

  function handleSendProcedure(procedure, reloadTable, step) {
    openModal(
      <SendProcedure
        openModal={openModal}
        procedure={procedure}
        step={step}
        reload={reloadTable}
        onClose={onClose}
      />,
    );
  }

  const handleBack = () => {
    navigate(-1);
  };

  if (!loading || !loadingValues) {
    return <Circle />;
  }

  const SINdnCod =
    data.listItems && validateArray(data.listItems)
      ? data.listItems?.map((objeto) => objeto.siNdnCod).join(", ")
      : "";

  const OPCarImpItmDscCom =
    data.listItems && validateArray(data.listItems)
      ? data.listItems.map((objeto) => objeto.opCarImpItmDscCom).join(", ")
      : "";

  const getActionsByStep = (step) => {
    const allActions = [
      {
        label: "Cotización",
        icon: "fas fa-hand-holding-usd",
        action: handleFormQuotes,
        color: "text-[#1d4ed8]",
      },
      {
        label: "Hoja de trabajo",
        icon: "fas fa-print",
        action: generateServiceOrder,
        color: "text-[#1d4ed8]",
      },
      {
        label: "Carta de entrega de documentos",
        icon: "fas fa-list",
        action: generateProofDeliveryDocument,
        color: "text-[#1d4ed8]",
      },
      {
        label: "Planilla",
        icon: "fas fa-file-contract",
        action: generateCustomsClearanceForm,
        color: "text-[#1d4ed8]",
      },
    ];

    // Retorna acciones según el paso
    if (step === 1) return [allActions[1]];
    if (step === 2) return [allActions[1]];
    if (step === 4) return [allActions[0]];
    if (step === 8) return [allActions[3]];
    if (step === 9) return [allActions[2]];
    return [];
  };

  return (
    <>
      <div className="flex bg-blue-100 px-2 py-2 mb-2 rounded-sm gap-2">
        <Button onClick={handleBack}>
          <i className="fas fa-angle-left"></i>
        </Button>
        <div className="w-1/3">
          {/* <h3 className="mb-2">
            <span className="font-medium">Hoja de ruta:</span>{" "}
            {data.procNumberString
              ? formattedValue(data.procNumberString)
              : "-"}
          </h3> */}
          <h3 className="mb-2">
            <span className="font-medium">Nro. interno:</span> {data.nroInterno}
          </h3>
          <h3 className="mb-2">
            <span className="font-medium">Fecha de inicio:</span>{" "}
            {dayjs(data.fechaInicio).format("DD/MM/YYYY HH:mm")}
          </h3>
          <h3 className="mb-2">
            <span className="font-medium">Nro. DIM/DEX:</span>{" "}
            {data.nroDim || "  ---"}
          </h3>
          <h3 className="mb-2">
            <span className="font-medium">Descripción partida:</span>{" "}
            {OPCarImpItmDscCom || " ---"}
          </h3>
        </div>
        <div className="w-1/3">
          <h3 className="mb-2">
            <span className="font-medium">Paso actual:</span>{" "}
            {`${data.step}. ${data.stepName}`}
          </h3>
          <h3 className="mb-2">
            <span className="font-medium">Cliente:</span>{" "}
            {data.companyName || "  ---"}
          </h3>
          <h3 className="mb-2">
            <span className="font-medium">Referencia cliente:</span>{" "}
            {data.refCliente || "  ---"}
          </h3>
        </div>
        <div className="w-1/3">
          <h3 className="mb-2">
            <span className="font-medium">Mercadería:</span>{" "}
            {data.mercaderia || "  ---"}
          </h3>
          <h3 className="mb-2">
            <span className="font-medium">Partida arancelaria:</span>{" "}
            {SINdnCod || "  ---"}
          </h3>
          <h3 className="mb-2">
            <span className="font-medium">Aduana:</span>{" "}
            {data.aduana || "  ---"}
          </h3>
        </div>
      </div>
      {dataValues && (
        <div className="flex gap-2 mb-2 justify-center">
          {dataValues?.analizarDocumentación === "true" && (
            <h3
              className={`space-x-2 ${
                dataValues["observaciones(RecepciónYRevisión)"]
                  ? "bg-green-100 text-green-600"
                  : "bg-slate-100 text-gray-600"
              } px-4 py-1 rounded-full`}
            >
              <i className="fas fa-check-circle"></i>
              <span className="font-medium">Analizar documentación</span>{" "}
            </h3>
          )}
          {dataValues?.elaborarDam === "true" && (
            <h3
              className={`space-x-2 ${
                dataValues["adjuntarDamFirmada"]
                  ? "bg-green-100 text-green-600"
                  : "bg-slate-100 text-gray-600"
              } px-4 py-1 rounded-full`}
            >
              <i className="fas fa-check-circle"></i>
              <span className="font-medium">Elaborar DAM</span>{" "}
            </h3>
          )}
          {dataValues?.elaborarLiquidaciónDeTributos === "true" && (
            <h3
              className={`space-x-2 ${
                dataValues["tributos"]
                  ? "bg-green-100 text-green-600"
                  : "bg-slate-100 text-gray-600"
              } px-4 py-1 rounded-full`}
            >
              <i className="fas fa-check-circle"></i>
              <span className="font-medium">
                Elaborar liquidación de Tributos
              </span>
            </h3>
          )}
          {dataValues?.elaborarDim === "true" && (
            <h3
              className={`space-x-2 ${
                dataValues["adjuntarDim"]
                  ? "bg-green-100 text-green-600"
                  : "bg-slate-100 text-gray-600"
              } px-4 py-1 rounded-full`}
            >
              <i className="fas fa-check-circle"></i>
              <span className="font-medium">Elaborar DIM</span>{" "}
            </h3>
          )}
          {dataValues?.elaborarDav === "true" && (
            <h3
              className={`space-x-2 ${
                dataValues["dav"]
                  ? "bg-green-100 text-green-600"
                  : "bg-slate-100 text-gray-600"
              } px-4 py-1 rounded-full`}
            >
              <i className="fas fa-check-circle"></i>
              <span className="font-medium">Elaborar DAV</span>{" "}
            </h3>
          )}
        </div>
      )}
      {data.steps && validateArray(data.steps) ? (
        <TableComplete
          // data={data}
          // call={call}
          // height={currentSize.height ? currentSize.height : null}
          // buttons={buttons}
          data={data.steps.filter((step) => step.step > 0)}
          onClick={handleStepForm}
          urlApi={`/procedure/${procedureId}/general`}
          header={[
            { name: "step", label: "Nro" },
            { name: "processStepName", label: "Paso" },
            {
              name: "startDate",
              label: "Estado",
              type: "custom",
              builder: (value, _, data) => {
                return (
                  <div
                    className={`w-fit text-white ${
                      data.finishDate && data.finishDate !== null
                        ? "bg-green-500 text-white"
                        : // ? "bg-[#4fce4431] text-gray-500"
                          value
                          ? "bg-blue-500"
                          : "bg-[#74747431] text-gray-500"
                    } text-center rounded-full py-1 px-4`}
                  >
                    {data.finishDate && data.finishDate !== null
                      ? "Completado"
                      : value
                        ? "En progreso"
                        : "No iniciado"}
                  </div>
                );
              },
            },
            { name: "startDate", label: "Inicio", type: "date" },
            { name: "finishDate", label: "Fin", type: "date" },
            {
              name: "rols",
              label: "Roles",
              type: "custom",
              builder: (rols) => {
                return (
                  <div className="flex flex-col gap-1">
                    {rols.map((rol) => (
                      <div
                        className="w-fit border-2 border-gray-500 rounded-md px-1"
                        key={rol.id}
                      >
                        {rol.label}
                      </div>
                    ))}
                  </div>
                );
              },
            },
            {
              name: "Reports",
              type: "custom",
              label: " ",
              sticky: true,
              builder: (value, head, item) => {
                const actions = getActionsByStep(item.step);
                return (
                  <div className="flex gap-4 ml-2">
                    {actions.map((act, index) => (
                      <div
                        key={index}
                        className={`${act.color} text-xl cursor-pointer border rounded-md px-2 py-1 bg-blue-200`}
                        onClick={(e) => {
                          e.stopPropagation();
                          act.action({ ...data, ...item });
                        }}
                      >
                        <Tooltip
                          title={act.label}
                          position="right"
                          trigger="mouseenter"
                        >
                          <i className={act.icon}></i>
                        </Tooltip>
                      </div>
                    ))}
                  </div>
                );
              },
            },
          ]}
        />
      ) : null}
    </>
  );
};

export default FolderStep;
